
import React from "react";
import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <Link to="/" className="flex items-center mr-8">
      <img 
        src="/logo.svg" 
        alt="Grandpal" 
        className="h-10"
        onError={(e) => {
          e.currentTarget.src = '/placeholder.svg';
          e.currentTarget.alt = 'Grandpal';
        }}
      />
    </Link>
  );
}
